import { gql } from '@apollo/client';

export const GET_UPLOAD_URL = gql`
	mutation GetUploadUrl($key: String!) {
		getUploadUrl(key: $key)
	}
`;
